<template>
  <div class="content__go-back-wrapper" :style="mini ? 'height: 30px' : 'height: 100px'">
    <a class="go-back" @click="$emit('click')">
      <span class="go-back__arrow">
        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.77624 14.6625L2.01381 8L8.77624 1.33754C9.07458 1.0347 9.07458 0.529969 8.77624 0.227129C8.4779 -0.0757098 7.98066 -0.0757098 7.58287 0.227129L0.223757 7.39432C-0.0745856 7.69716 -0.0745856 8.20189 0.223757 8.50473L7.48343 15.7729C7.78177 16.0757 8.27901 16.0757 8.6768 15.7729C9.07458 15.47 9.07458 14.9653 8.77624 14.6625Z" fill="#808080"/>
        </svg>
      </span>
      <p class="go-back__text">{{ text }}</p>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'Назад к меню'
    },
    mini: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
